/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import logo from "./customer-pinterest.svg";
import Company from "./company";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      strong: "strong",
      blockquote: "blockquote"
    }, props.components), {Header} = _components;
    if (!Header) _missingMdxReference("Header", true);
    return _jsxs(_Fragment, {
      children: [_jsxs("article", {
        children: [_jsx(Header, {}), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "My day job:"
          }), " I gather data about our environmental impact, translate it into meaningful insights for my cross-functional partners, and help them develop plans to reduce our footprint."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "My climate background:"
          }), " I’d been doing aspects of this work for a long time before I got the formal title. I’ve always been passionate about the role the private sector can and should play in addressing the climate crisis, and I’m motivated by the scale of impact we can have as a company."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "My approach:"
          }), " I tailor my communication to make it clear how day-to-day decisions make an impact, what’s at stake, and how everyone can play a role. My goal is to connect with as many people here as possible so that I can understand their priorities and we can figure out how to incorporate a sustainability mindset into their work."]
        })]
      }), "\n", _jsxs(Company, {
        name: "Pinterest",
        logo: logo,
        children: [_jsx(_components.p, {
          children: "Helping people discover things they love, and inspiring them to go do those things in their daily lives—including pro-climate activities they might have not considered before."
        }), _jsx(_components.p, {
          children: "Using data to drive sustainable decision-making in all aspects—including facilities, vendors, and employee food choices."
        })]
      }), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Climate work is an opportunity to think 5, 10, 15 years into the future about ", _jsx("mark", {
            children: "how the decisions we make today will build a better tomorrow"
          }), "."]
        }), "\n"]
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
